import { render, staticRenderFns } from "./EditDoctorInfo.vue?vue&type=template&id=c47ddbc4&scoped=true"
import script from "./EditDoctorInfo.vue?vue&type=script&lang=js"
export * from "./EditDoctorInfo.vue?vue&type=script&lang=js"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./EditDoctorInfo.vue?vue&type=style&index=1&id=c47ddbc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47ddbc4",
  null
  
)

export default component.exports